import {
  formatIndiaDate,
  formatIndiaDateTime,
  todayIndiaIsoDate,
} from "./indiaTime";

/** Short date for list rows (gate, weighbridge, unloading) — IST. */
export function formatListDate(iso) {
  return formatIndiaDate(iso, { day: "2-digit", month: "short", year: "numeric" });
}

export function formatListDateTime(iso) {
  return formatIndiaDateTime(iso);
}

export { todayIndiaIsoDate as todayIsoDate };

/** Gate pass / purchase trace line: date · vehicle · gate pass. */
export function purchaseTraceMeta(p) {
  const parts = [];
  const date = formatListDate(p?.created_at || p?.gate_pass_created_at);
  if (date) parts.push(date);
  if (p?.vehicle_number) parts.push(String(p.vehicle_number).toUpperCase());
  if (p?.gate_pass_code) parts.push(p.gate_pass_code);
  return parts.length ? parts.join(" · ") : null;
}

export function gatePassTraceMeta(g) {
  const parts = [];
  const date = formatListDate(g?.created_at);
  if (date) parts.push(date);
  if (g?.vehicle_number) parts.push(String(g.vehicle_number).toUpperCase());
  if (g?.code) parts.push(g.code);
  return parts.length ? parts.join(" · ") : null;
}

/** Compact truck label for select trigger (unloading, etc.). */
export function purchaseTruckShortLabel(p) {
  if (!p) return "";
  const trace = purchaseTraceMeta(p);
  return trace ? `${p.code} · ${trace}` : p.code || "—";
}

/** One-line truck option in dropdown. */
export function purchaseTruckOptionLabel(p) {
  if (!p) return "—";
  const trace = purchaseTraceMeta(p);
  const load = p.unload_by_qtl
    ? p.loose_unloaded_qtl
      ? `${p.loose_unloaded_qtl} qtl unloaded`
      : "loose"
    : `${p.bags_reported || 0} bags`;
  const assign = p.assigned_to ? ` · → ${p.assigned_to}` : "";
  return `${p.code} — ${p.party_name || "—"}${trace ? ` · ${trace}` : ""} · ${load}${assign}`;
}
